import React from "react";
import { usePrefs } from "@/contexts/PrefsContext";

export const Logo = ({ light = false, size = "md" }: { light?: boolean; size?: "md" | "lg" }) => {
  const { t } = usePrefs();
  const box = size === "lg" ? "h-20 w-20 rounded-3xl" : "h-10 w-10 rounded-2xl";
  return (
    <span className="inline-flex items-center gap-2 select-none" data-testid="app-logo">
      <span className={`grid place-items-center bg-white shadow-md ring-1 ring-black/5 overflow-hidden ${box}`}>
        <img src="/logo.png" alt={t("appName")} width={80} height={80} className="h-full w-full object-contain p-0.5" data-testid="app-logo-image" />
      </span>
      {size === "md" && (
        <span className={`font-display text-xl font-black tracking-tight ${light ? "text-white" : "text-foreground"}`}>{t("appName")}</span>
      )}
    </span>
  );
};
